<section id="project1" class="projects" data-scroll-nav="0">
	<div class="container-fluid">
		<div class="row">
			<div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto">
				<div class="row">
					<div class="col-xl-7 col-md-7 col-sm-6" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
						<div class="d-flex flex-column justify-content-center h-100 service-content">
							<div>
								<h1 class="heading">AUTOKOOROSH</h1>
								<div class="points">
									<p>One of the leading auto repair shops serving customers in dubai. All mechanic services are performed by highly qualified mechanics.</p>
									<p> <a class="text-decoration-underline" href="https://autokoorosh.ae/" target="_blank">autokoorosh.ae</a>
									</p>
								</div>
							</div>
						</div>
					</div>
					<div class="col-xl-5 col-md-5 col-sm-6">
						<div class="d-flex flex-column justify-content-center align-items-sm-end">
							<div class="list-block">
								<h3 class="mt-0 mb-2" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100"><a
										href="{{Url}}/project-details/autokoorosh#branding">Branding</a></h3>
								<h3 class="mt-0 mb-2" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="150"><a
										href="{{Url}}/project-details/autokoorosh#ui-ux">UI/UX Design</a></h3>
								<!-- <h3 class="mt-0 mb-2" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="200"><a
										href="{{Url}}/project-details/beyou#ecommerce">Ecommerce</a></h3> -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<section data-scroll-nav="1" class="pb-0">
	<div class="container-fluid p-0">
		<div class="row">
			<div class="col-md-12 p-0" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
				<img src="{{baseUrl}}/images/projects/autokoorosh/autokoorosh-banner-min.png" alt="Branding and web development agency" width="" height="" loading="lazy">
			</div>
		</div>
	</div>
</section>
<section class="section bg-autokoorosh about" data-scroll-nav="2">
	<div class="container">
		<div class="row">
			<div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-md-0 mx-sm-auto mx-auto" data-aos="fade-up"
				data-aos-duration="2000" data-aos-delay="100">
				<div class="content">
					<p class="mb-0">Autokoorosh, an established auto service provider, embarked on a digital journey with Pixtar, a renowned web development agency.
            With a track record of 15 years of delivering quality car repair and detailing services, Autokoorosh has earned maximum customer satisfaction.
          <br>
					<br>
          Despite their longstanding success in the auto service industry, Autokoorosh recognized the need to enhance their online presence to better serve their customers
           and expand their reach. Pixtar was tasked with developing a website that not only reflected Autokoorosh's commitment to quality services but also showcased their work
            and diversified offerings.</p>
				</div>				
			</div>
		</div>
	</div>
</section>
<section class="bg-autokoorosh branding pb-0" id="branding" data-scroll-nav="3">
  <div class="container">
    <div class="row">
      <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-11 col-11 mx-md-0 mx-sm-auto mx-auto" data-aos="fade-up" data-aos-duration="2000"
        data-aos-delay="100">
        <div class="content">
          <h1 class="heading mb-0">Branding</h1>
          <p>Through cohesive branding efforts, Pixtar helped Autokoorosh strengthen its brand presence, establish credibility in the market, and attract new customers. The synergy between web development and branding ensured a holistic approach to enhancing Autokoorosh's overall marketing strategy and driving business growth.</p>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="bg-autokoorosh branding" id="branding1">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12 p-0" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
				<div class="imglist mb-3">
					<img src="{{baseUrl}}/images/projects/autokoorosh/autokoorosh-branding.png" alt="Design and web development agency" width="" height="" loading="lazy">
				</div>
			</div>
			<div class="col-xxl-10 col-xl-11 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto">
				<div class="row">
					<div class="col-xl-6 col-lg-6 col-md-6 mx-lg-auto ps-md-0" data-aos="fade-up" data-aos-duration="2000"
						data-aos-delay="100">
						<img src="{{baseUrl}}/images/projects/autokoorosh/autokoorosh-left.png" alt="web designing agency" width="" height="" loading="lazy">
					</div>
					<div class="col-xl-6 col-lg-6 col-md-6 ps-md-0" data-aos="fade-up" data-aos-duration="2000"
						data-aos-delay="100">
						<div class="list">
							<img src="{{baseUrl}}/images/projects/autokoorosh/autokoorosh-right.png" alt="Brand agency" width="" height="" loading="lazy">
							<!-- <img src="{{baseUrl}}/images/projects/beyou/pack.jpg" alt="envelop" width="" height=""> -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="bg-autokoorosh typography" data-scroll-nav="5">
	<div class="container-fluid">
		<div class="row">
			<div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto">
				<div class="typography" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
					<img src="{{baseUrl}}/images/projects/autokoorosh/typography.png" alt="Branding agency in Dubai " width="" height="" loading="lazy">
          <p data-aos="fade-up" data-aos-duration="2500" data-aos-delay="100">Through cohesive branding efforts, Pixtar helped Autokoorosh strengthen its brand presence, 
            establish credibility in the market, and attract new customers. The synergy between web development and branding ensured a holistic approach to enhancing Autokoorosh's 
            overall marketing strategy and driving business growth.</p>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="section ui-ux" id="ui-ux" data-scroll-nav="8">
	<div class="container-fluid">
		<div class="row">
			<div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto">
				<div class="row mb-4">
					<div class="col-xxl-5 col-xl-6 col-lg-8 col-md-10 col-sm-10" data-aos="fade-up" data-aos-duration="2000"
						data-aos-delay="100">
						<div class="content">
							<h1 class="heading mb-2">UI/UX Design</h1>
							<p class="">Pixtar crafted a dynamic and user-friendly website for Autokoorosh, highlighting their core services of car repairing and detailing. The website was designed 
                to provide visitors with easy access to information about Autokoorosh's services, locations, and contact details. Integration of interactive features facilitated seamless
                 communication between Autokoorosh and its customers</p>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-lg-9 mx-lg-auto" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
						<video class="w-100 h-auto desktopimg" id="myVideo3" width="320" height="176" autoplay="true" muted="muted"
							loop="true" oncanplay="this.play()" onloadedmetadata="this.muted = true">
							<source src="{{baseUrl}}/images/projects/autokoorosh/autokoorosh-desktop.mp4" type="video/mp4">
							<source src="{{baseUrl}}/images/projects/autokoorosh/autokoorosh-desktop.ogg" type="video/ogg">
							Your browser does not support HTML5 video.
						</video>
						<video class="w-100 h-auto" id="myVideo3" width="320" height="176" autoplay="true" muted="muted" loop="true"
							oncanplay="this.play()" onloadedmetadata="this.muted = true">
							<source src="{{baseUrl}}/images/projects/autokoorosh/autokoorosh_laptop.mp4" type="video/mp4">
							<source src="{{baseUrl}}/images/projects/autokoorosh/autokoorosh_laptop.ogg" type="video/ogg">
							Your browser does not support HTML5 video.
						</video>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="technical" id="technical" data-scroll-nav="8">
	<div class="container">
		<div class="row">
			<div class="col-xxl-10 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-md-0 mx-sm-auto mx-auto">
				<div class="row mb-4">
					<div class="col-xxl-10 col-xl-12 col-lg-12 col-md-12 col-sm-12" data-aos="fade-up" data-aos-duration="2000"
						data-aos-delay="100">
						<div class="content">
							<p class="mb-md-4 -sm-3 mb-2">Pixtar's collaboration with Autokoorosh resulted in a successful digital transformation, positioning them as a leader in the auto service 
                industry. The new website not only improved customer engagement but also strengthened Autokoorosh's brand identity and facilitated business growth. Through strategic web 
                development, Pixtar helped Autokoorosh drive excellence in auto services and expand its reach in the competitive Dubai market.</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="next bg-black pb-0" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
	<div class="container">
		<div class="row">
			<div class="col-md-12">
				<div class="next-block">
					<div class="in-line">
            <!-- {{Url}}/project-details/autokoorosh -->
						<a href="{{Url}}/project-details/vendetta" class="text-white font-bold">
							<img src="{{baseUrl}}/images/projects/vendetta/vendetta-banner-min.png" alt="Creative agency Dubai" width="280"
								height="280" loading="lazy">
							<h1 class="heading text-white">NEXT
								PROJECT</h1>
						</a>
					</div>
				</div>
			</div>
		</div>
		<div class="line"></div>
	</div>
</section>